import * as ReactQuery from 'react-query';
import { InferMutationOptions } from 'utils/types';
import { QUERY_KEY_ALL_DELIVERIES } from '../get-all-deliveries';
import { deleteDeliveryApi } from './api';

export function useDeleteDelivery(
  options?: InferMutationOptions<typeof deleteDeliveryApi>,
) {
  const queryClient = ReactQuery.useQueryClient();
  const { mutate: deleteDelivery, ...rest } = ReactQuery.useMutation(
    ['deleteDeliveryApi'],
    deleteDeliveryApi,
    {
      ...options,
      onSuccess: async (data, variables, context) => {
        await queryClient.invalidateQueries(QUERY_KEY_ALL_DELIVERIES);

        if (options?.onSuccess) {
          await options.onSuccess(data, variables, context);
        }
      },
    },
  );

  return { deleteDelivery, ...rest };
}
